'use client';
import { jsx } from 'react/jsx-runtime';
import { useState } from 'react';
import { IconUser } from '../../svg/icons/icon-user.js';
import '../../util/formatters/format-date.js';
import { formatName } from '../../util/formatters/format-name.js';
import 'date-fns';
import 'date-fns/locale';
import '../../util/datetime/constants.js';
import '../../util/datetime/comparators.js';
import '../../types/order.js';
import { getUrlString } from '../../util/get-url-string.js';
import { useComponentBoundingBox } from '../../util/use-component-bounding-box.js';

const COLORS = [
    '#D93F0B', // Red orange
    '#0E8A16', // Green
    '#1D76DB', // Blue
    '#5319E7', // Purple
    '#EF8509', // Orange
    '#4D5FBB', // Indigo
    '#F1CAFF', // Lavender
    '#49CAF3', // Sky blue
    '#F5C724', // Yellow
    '#FB5A42', // Red
];
const getInitials = (firstName, lastName) => {
    return (firstName.charAt(0) + lastName.charAt(0)).toUpperCase();
};
const generateSimpleHashCode = (str) => {
    return str
        .split('')
        .reduce((hashCode, char) => hashCode + char.charCodeAt(0), 0);
};
const OBJECT_FIT_TO_CLASS = {
    fill: 'object-fill',
    contain: 'object-contain',
    cover: 'object-cover',
    none: 'object-none',
    'scale-down': 'object-scale-down',
};
const ProfileImage = ({ className = '', pictureLink, objectFit = 'cover', firstName, lastName, anonymous = false, }) => {
    const [showPictureLink, setShowPictureLink] = useState(!anonymous);
    const [ref, size] = useComponentBoundingBox();
    const hasName = !!firstName && !!lastName;
    const formattedName = hasName ? formatName({ firstName, lastName }) : '';
    if (!anonymous && !!pictureLink && showPictureLink) {
        return (jsx("img", { className: `shrink-0 rounded-full ${OBJECT_FIT_TO_CLASS[objectFit]} ${className}`, src: getUrlString(pictureLink, {
                fit: 'crop',
                crop: 'faces',
                h: (size?.height ?? 0) * 4,
                w: (size?.width ?? 0) * 4,
            }), alt: formattedName, onError: (e) => {
                console.warn(e);
                setShowPictureLink(false);
            }, ref: ref, referrerPolicy: "no-referrer" }));
    }
    if (anonymous || !hasName) {
        return (jsx("div", { className: `flex shrink-0 items-center justify-center rounded-full bg-leland-gray-hover text-white ${className}`, role: "img", ref: ref, children: jsx(IconUser, { className: "size-2/3 text-leland-gray-dark" }) }));
    }
    const initials = getInitials(firstName, lastName);
    const simpleHashCode = generateSimpleHashCode(initials);
    const backgroundColor = COLORS[simpleHashCode % COLORS.length];
    const fontSize = (size?.height ?? 0) / 2;
    return (jsx("div", { className: `flex shrink-0 items-center justify-center rounded-full leading-none text-white ${className}`, role: "img", "aria-label": formattedName, style: { backgroundColor, fontSize }, ref: ref, children: initials }));
};

export { ProfileImage };
//# sourceMappingURL=profile-image.js.map
